import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {UpmPlantProvider} from '@hconnect/upm'
import {usePlantUpmIdFromHierarchyId} from '@hproduce/suite-core'
import {ThemeProvider} from '@mui/material'
import {RouteObject} from 'react-router'

import {refractoryMaterialsFeatureTranslations} from '../localization'
import {RefractoryMaterialsPage} from '../pages'

const SuiteRefractoryMaterialsPage = () => {
  const plantUpmId = usePlantUpmIdFromHierarchyId()

  return (
    <UpmPlantProvider plantUpmId={plantUpmId}>
      <RefractoryMaterialsPage />
    </UpmPlantProvider>
  )
}

const SuiteRefractoryMaterialsRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={refractoryMaterialsFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <SuiteRefractoryMaterialsPage />
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const refractoryMaterialsRoute: RouteObject = {
  path: '',
  element: <SuiteRefractoryMaterialsRouteWrapper />
}
